import { render, staticRenderFns } from "./bobao.vue?vue&type=template&id=1ac08055&"
import script from "./bobao.vue?vue&type=script&lang=js&"
export * from "./bobao.vue?vue&type=script&lang=js&"
import style0 from "./bobao.vue?vue&type=style&index=0&id=1ac08055&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports